import {
  useScript,
  type UseScriptReturn,
} from "@/shared/composables/useScript";
import { PAYABLI_SCRIPT_URL } from "@/shared/utils/env";

type OnLoadedType = UseScriptReturn["onLoaded"];
type LoadType = UseScriptReturn["load"];

export interface UsePayabliScript {
  onLoaded: OnLoadedType;
  loadScript: LoadType;
}

/**
 * Composable for loading the Payabli embed script
 * @returns Payabli script loading utilities
 */
export const usePayabliScript = (): UsePayabliScript => {
  const { onLoaded, load } = useScript(
    {
      src: PAYABLI_SCRIPT_URL + "component.js",
      referrerpolicy: false,
      async: false,
      crossorigin: false,
    },
    {
      trigger: "manual",
    }
  );

  return { onLoaded, loadScript: load };
};
